// extracted by mini-css-extract-plugin
export default {"container":"TaskNote_container__QuPBo","wrapper":"TaskNote_wrapper__a9EbD","title":"TaskNote_title__lv4pk","close":"TaskNote_close__90rzW","body":"TaskNote_body__vTev4"};